import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_ClientCfars = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_ClientCfars' className='file-pdf-document'>
            <div className='file-template'>
            <h3>ALCOHOL, DRUG ABUSE & MENTAL HEALTH CFARS FORM </h3>
                <p className='w-750'>(* Mandatory Fields)</p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>1. *CLIENT SSN: </span>

                            <input type='text' id='txtClientSsn' name='txtClientSsn' className='add-only' />



                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>2. *CONTRACTOR ID:</span>
                            <input type='text' id='txtContractorId' name='txtContractorId'  className='add-only' />
                            Federal Employer ID# of agency directly contracted with SAMH. If your agency is subcontracted, enter the ID# of the contractor/ASO here.
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>3. *DCF EVALUATION (PURPOSE) :</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='cbDcfEvaluation_AdmissionInitiation' name='cbDcfEvaluation' className='add-only' value='AdmissionInitiationIntoEpisodeOfCare' /> Admission/initiation into episode of care
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='cbDcfEvaluation_SixMonthInterval' name='cbDcfEvaluation' className='add-only' value='SixMonthIntervalAfterAdmission' /> Six (6) month interval after admission
                        </td>


                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='cbDcfEvaluation_DischargeFromAgency' name='cbDcfEvaluation' className='add-only' value='DischargeFromAgency' /> Discharge from agency
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='cbDcfEvaluation_AdministrativeDischarge' name='cbDcfEvaluation' className='add-only' value='AdministrativeDischarge' /> Administrative Discharge
                        </td>
                    </tr>
                        <tr>
                            <td className='w-750'>
                                <input type='radio' id='cbDcfEvaluation_None' name='cbDcfEvaluation' className='add-only' value='NoneOfTheAbove' /> None of the above
                            </td>

                        </tr>



                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>4. *EVALUATION DATE: </span>

                            <input type='date' id='txtEvaluationDate' name='txtEvaluationDate' className='add-only' />
                            <br /><br /><br /><br />

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>5. *Provider ID:</span>
                            <input type='text' id='txtProviderID' name='txtProviderID' placeholder='27-3864837' className='add-only' />
                            Federal Employer ID# of the provider agency actually completing the CFARS. Subcontracted agencies Tax ID# goes here. Contractor agencies reenter the Contractor ID.


                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>6. PROGRAM EVALUATION: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbProgramEvaluation_AdmissionToProgram' name='rbProgramEvaluation' className='add-only' value='Admission to program or service' /> Admission to program or service
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbProgramEvaluation_SixMonthsAfterAdmission' name='rbProgramEvaluation' className='add-only' value='Six (6) months after admission to program or service' /> Six (6) months after admission to program or service
                        </td>
                    </tr>
                    <tr>
                    <td className='w-375'>
                            <input type='radio' id='rbProgramEvaluation_AnnuallyAfterAdmission' name='rbProgramEvaluation' className='add-only' value='Annually after admission to program or service' /> Annually after admission to program or service
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbProgramEvaluation_PlannedDischarge' name='rbProgramEvaluation' className='add-only' value='' /> Planned discharge from/transfer to program/service in agency
                        </td>
                    </tr>
                    <tr>
                    <td className='w-375'>
                            <input type='radio' id='rbProgramEvaluation_AdministrativeDischarge' name='rbProgramEvaluation' className='add-only' value='Administrative discharge' /> Administrative discharge
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbProgramEvaluation_None' name='rbProgramEvaluation' className='add-only' value='None of the above' /> None of the above
                        </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>7. *RATER EDUCATION / SPECIALTY: </span>
                            <input type='text' id='txtRaterEducationSpecialty' name='txtRaterEducationSpecialty' className='add-only' />

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>8. *RATER FMHI CERTICATION# :</span>
                            <input type='text' id='txtRaterFmhiCertication' name='txtRaterFmhiCertication' className='add-only' />

                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>9. *SUBSTANCE ABUSE HISTORY:</span>
                            <select id='ddlSubstanceAbuseHistory' name='ddlSubstanceAbuseHistory' className='add-only'>
                                <option value='NA'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <table>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubAbuseHis_NoProblem' name='cbSubAbuseHis' className='add-only' value='No Problem' />  1.  No Problem
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubAbuseHis_Slight' name='cbSubAbuseHis' className='add-only' value='Slight to Moderate Problem' /> 4. Slight to Moderate Problem
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubAbuseHis_Severe' name='cbSubAbuseHis' className='add-only' value='Severe Problem' /> 7. Severe Problem
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubAbuseHis_LessThanSlight' name='cbSubAbuseHis' className='add-only' value='Less than Slight Problem' /> 2. Less than Slight Problem
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubAbuseHis_ModerateProblem' name='cbSubAbuseHis' className='add-only' value='Moderate Problem' /> 5. Moderate Problem
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubAbuseHis_SevereExtreme' name='cbSubAbuseHis' className='add-only' value='Severe/Extreme Problem' /> 8. Severe/Extreme Problem
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubAbuseHis_SlightProblem' name='cbSubAbuseHis' className='add-only' value='Slight Problem' /> 3. Slight Problem
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubAbuseHis_ModerateSevere' name='cbSubAbuseHis' className='add-only' value='Moderate /Severe Problem' /> 6. Moderate /Severe Problem
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubAbuseHis_ExtremeProblem' name='cbSubAbuseHis' className='add-only' value='Extreme Problem' /> 9. Extreme Problem
                        </td>
                    </tr>
                </table>
                <h5>Respond to questions 10 through 25 with the appropriate rating for this scale.</h5>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>10. *DEPRESSION SCALE:</span>
                            <input type='text' id='txtdepressionScale' name='txtdepressionScale' className='add-only' />

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>18. *INTERPERSONAL RELATIONSHIP SCALE:</span>
                            <input type='text' id='txtInterpersonalRelationshipScale' name='txtInterpersonalRelationshipScale' className='add-only'/>

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>11. *ANXIETY SCALE: </span>
                            <input type='text' id='txtAnxietyScale' name='txtAnxietyScale' className='add-only'/>

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>19. *BEHAVIOR IN HOME SETTINGSCALE:</span>
                            <input type='text' id='txtBehaviorInHomeSettingscale' name='txtBehaviorInHomeSettingscale' className='add-only'/>

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>12. *HYPERACTIVITY SCALE: </span>
                            <input type='text' id='txtHyperactivityScale' name='txtHyperactivityScale' className='add-only'/>

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>20.* ACTIVITIES OF DAILY LIVING (ADL) SCALE:</span>
                            <input type='text' id='txtActivitiesOfDailyLiving' name='txtActivitiesOfDailyLiving' className='add-only'/>

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>13. *THOUGHT PROCESS SCALE: </span>
                            <input type='text' id='txtThoughtProcessScale' name='txtThoughtProcessScale' className='add-only'/>

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>21. *SOCIO-LEGAL SCALE:</span>
                            <input type='text' id='txtSocioLegalScale' name='txtSocioLegalScale' className='add-only'/>

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>14. *COGNITIVE PERFORMANCE SCALE: </span>
                            <input type='text' id='txtCognitivePerformanceScale' name='txtCognitivePerformanceScale' className='add-only'/>

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>22.* WORK / SCHOOL SCALE:</span>
                            <input type='text' id='txtWorkSchoolScale' name='txtWorkSchoolScale' className='add-only'/>

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>15.* MEDICAL/PHYSICAL SCALE: </span>
                            <input type='text' id='txtMedicalPhysicalScale' name='txtMedicalPhysicalScale' className='add-only' />

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>23. *DANGER TO SELF SCALE:</span>
                            <input type='text' id='txtDangerToSelfScale' name='txtDangerToSelfScale' className='add-only' />

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>16.* TRAUMATIC STRESS SCALE: </span>
                            <input type='text' id='txtTraumaticStressScale' name='txtTraumaticStressScale' className='add-only' />

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>24. *DANGER TO OTHERS SCALE:</span>
                            <input type='text' id='txtDangerToOthersScale' name='txtDangerToOthersScale' className='add-only' />

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>17* SUBSTANCE USE SCALE: </span>
                            <input type='text' id='txtSubstanceUseScale' name='txtSubstanceUseScale' className='add-only' />

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>25. *SECURITY MANAGEMENT NEEDS:</span>
                            <input type='text' id='txtSecurityManagementNeeds' name='txtSecurityManagementNeeds' className='add-only' />

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>26. *CONTRACT NUMBER 1: </span>
                            <input type='text' id='txtContractNumber_1' name='txtContractNumber_1' className='add-only' />

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>28. CONTRACT NUMBER 3:</span>
                            <input type='text' id='txtContractNumber_3' name='txtContractNumber_3' className='add-only' />

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> 27. CONTRACT NUMBER 2: </span>
                            <input type='text' id='txtContractNumber_2' name='txtContractNumber_2' className='add-only' />

                        </td>
                        <td className='w-375'>&nbsp;


                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>29. PROVIDER INFORMATION: </span>
                            <textarea id='txtProviderInformation' name='txtProviderInformation' className='add-only'></textarea>

                        </td>

                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> 30. Medicaid Recipient ID:</span>
                            <input type='text' id='txtMedicaidRecipientId' name='txtMedicaidRecipientId' className='add-only'/>

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>32. MCO ID:</span>
                            <input type='text' id='txtMcoId' name='txtMcoId' className='add-only'/>

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> 31. Medicaid Provider ID: </span>
                            <input type='text' id='txtMedicaidProviderID' name='txtMedicaidProviderID' className='add-only'/>

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>33. County of Service:</span>
                            <input type='text' id='txtCountyOfService' name='txtCountyOfService' className='add-only'/>

                        </td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='signature w-600'> &nbsp;
                        </td>

                        <td className='signature w-150'> &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Signature:
                        </td>
                        <td className='small w-150'> Date:
                        </td>

                    </tr> 
                </table>



                
            </div>
        </form>

    )
}











